var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWifiEnabling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_wifi_enabling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_wifi_enabling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40-Copy-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-3",
    stroke: "#333333",
    fill: "#FFFFFF",
    cx: 9,
    cy: 9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_wifi",
    transform: "translate(3.000000, 5.000000)",
    fill: "#1D3648"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.63446391 L1.09090909,3.79183411 C3.80181818,0.915769169 8.19818182,0.915769169 10.9090909,3.79183411 L12,2.63446391 C8.68909091,-0.878154638 3.31636364,-0.878154638 0,2.63446391 L0,2.63446391 Z M4.36363636,7.2639447 L6,9 L7.63636364,7.2639447 C6.73636364,6.30332744 5.26909091,6.30332744 4.36363636,7.2639447 L4.36363636,7.2639447 Z M2.18181818,4.94920431 L3.27272727,6.10657451 C4.77818182,4.50940363 7.22181818,4.50940363 8.72727273,6.10657451 L9.81818182,4.94920431 C7.71272727,2.71547983 4.29272727,2.71547983 2.18181818,4.94920431 L2.18181818,4.94920431 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifiEnabling);
export default __webpack_public_path__ + "static/media/icon_wifi_enabling.4f6a7d7c4806a143f9e2b7c94c0f5b2f.svg";
export { ForwardRef as ReactComponent };